define(
    'viewmodels/trialcancelled',[
        "viewmodels/ViewModel",
        "services/config",
        "plugins/router",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (ViewModel, config, router, documentsService, i19n) {

        var vm = new ViewModel(
        {
            i19n: i19n
        });

        vm.activate = function () {
            sessionStorage.removeItem("view-library-id");
            sessionStorage.removeItem("view-list-id");

            localStorage.removeItem("culture");
            localStorage.removeItem("instanceCodeStatus");
            localStorage.removeItem("explorer-window-settings");
        };
        vm.attached = function () {
        };

        vm.clickHelp = function () {
            window.open('http://help.fileplan.com');
        };

        return vm;

    }
);
